// 是否合格状态列表
export const standardStatusArr = [
  { label: '合格', value: 1 },
  { label: '不合格', value: 2 }
]

// 是否合格状态字典
export const standardStatusMap = {
  1: '合格',
  2: '不合格'
}

// 整改状态列表
export const rectificationStatusArr = [
  { label: '待指派', value: 1 },
  { label: '待整改', value: 2 },
  { label: '待验收', value: 3 },
  { label: '已完成', value: 4 }
]

// 整改状态字典
export const rectificationStatusMap = {
  1: '待指派',
  2: '待整改',
  3: '待验收',
  4: '已完成'
}

// 工序列表
export const unqualifiedProcessArr = [
  { label: '钢筋绑扎', value: 'reinforcementBind' },
  { label: '模板安装', value: 'templateMounting' },
  { label: '砼浇筑', value: 'concretePlacement' },
  { label: '振捣', value: 'vibrate' },
  { label: '养护', value: 'maintain' },
  { label: '张拉', value: 'tensioning' },
  { label: '压浆', value: 'pressMortar' },
  { label: '封锚', value: 'moorUp' }
]

// 工序字典
export const unqualifiedProcessMap = {
  reinforcementBind: '钢筋绑扎',
  templateMounting: '模板安装',
  concretePlacement: '砼浇筑',
  vibrate: '振捣',
  maintain: '养护',
  tensioning: '张拉',
  pressMortar: '压浆',
  moorUp: '封锚'
}

// 是否全部完成整改状态列表
export const rectificationStatusAllArr = [
  { label: '是', value: 1 },
  { label: '否', value: 2 }
]

// 是否全部完成整改状态字典
export const rectificationStatusAllMap = {
  1: '是',
  2: '否',
  3: '暂无整改信息'
}
